import axios from "axios";
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  login: "Account/login",
  details: "Account/details",
  editProfile: "Account/edit-profile",
  uploadImage: "Account/upload-image",
  getQRCode: "Account/qrcode",
  refresh: "Account/refresh",
  getStudentImage: (imageName) => `Account/GetImage/${imageName}`,
};

export const createIdentityAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/" + endpoint + "/";
  const token = sessionStorage.getItem("token");
  return {
    fetch: () =>
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    fetchWithOptions: (options) =>
      axios.get(url, {
        ...options,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),

    post: (newRecord) => axios.post(url, newRecord),

    postWithOptions: (newRecord, options = {}) =>
      axios.post(url, newRecord, { ...options }),

    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    putWithToken: (updatedRecord) =>
      axios.put(url, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};
